import GATSBY_COMPILED_MDX from "/opt/buildhome/repo/content/blog/blog-howToSayHowAreYou.mdx";
import React, {Component} from 'react';
import {graphql} from 'gatsby';
import SEO from '../components/SEO';
import Layout from '../layouts/index';
import SocialShare from '../components/social-share';
import Comments from '../components/Comments';
import MailChimpBanner from '../components/Mailchimp-banner';
import PromoBanner from '../components/PromoBanner';
import LHTBanner from '../components/LHTBanner';
import ContentBanner from '../components/ContentBanner';
import {GatsbyImage, getImage, getSrc} from 'gatsby-plugin-image';
import BuyMeCoffee from '../components/BuyMeCoffee';
class BlogPostTemplate extends Component {
  constructor(props) {
    super(props);
    this.frontmatter = props.data.mdx.frontmatter;
    this.disqusProps = {
      shortname: 'HowToVietnamese',
      config: {
        identifier: props.pageContext.id,
        title: this.frontmatter.title
      }
    };
    this.category = this.frontmatter.category;
    this.title = `${this.frontmatter.title}`;
    this.path = this.frontmatter.path;
    this.id = props.pageContext.id;
    this.excerpt = this.frontmatter.excerpt;
    this.keywords = this.frontmatter.keywords;
    this.image = this.frontmatter.image;
    this.url = `https://howtovietnamese.com${this.path}`;
    this.canonicalUrl = null;
    if (this.path.includes('how-long-to-learn-vietnamese') || this.path.includes('vietnamese-alphabet-tones')) {
      this.canonicalUrl = 'https://langi.app/blog' + this.path;
    }
  }
  render() {
    const seoImage = getSrc(this.image);
    const headerImage = getImage(this.image);
    return React.createElement(Layout, {
      bodyclassName: "page-service"
    }, React.createElement(SEO, {
      title: this.title,
      keywords: this.keywords,
      image: seoImage,
      description: this.excerpt,
      url: this.url,
      canonicalUrl: this.canonicalUrl
    }), React.createElement(PromoBanner), React.createElement("div", {
      id: "postContainer",
      className: "contentContainer margin-from-header bg-white"
    }, React.createElement("div", {
      className: "container mt-0 mt-md-2"
    }, React.createElement("div", {
      className: "row justify-content-center"
    }, React.createElement("div", {
      className: "col-12 col-md-10 pr-0 pl-0"
    }, React.createElement("div", {
      className: "post-single bg-white mb-4 pt-4 pt-md-8 pl-2 pr-2 pl-md-5 pr-md-5"
    }, React.createElement("h1", null, this.title))), React.createElement("div", {
      className: "col-12 col-md-10 pl-0 pr-0"
    }, headerImage ? React.createElement(GatsbyImage, {
      image: headerImage,
      alt: this.title
    }) : null, React.createElement(ContentBanner, {
      isTransparent: "true"
    }))), React.createElement("div", {
      className: "row justify-content-center mt-4 mt-md-8"
    }, React.createElement("div", {
      className: "col-12 col-md-7 pr-0 pl-0 pl-md-0"
    }, React.createElement("div", {
      className: "post-single bg-white pb-0 pb-md-2 pl-2 pr-2 pl-md-0 pr-md-0"
    }, this.props.children, React.createElement("div", {
      className: "border rounded bmac-container box-shadow mt-6 mt-md-8 pt-4 pb-4"
    }, React.createElement("div", {
      className: "row justify-content-center"
    }, React.createElement("p", {
      className: "font-weight-bold text-align-center ml-3 mr-3 ml-md-0 mr-md-0 mb-2"
    }, "Loving the content? Support me with a Coffee ❤️"), React.createElement("div", {
      className: "col-9 col-md-5"
    }, React.createElement(BuyMeCoffee)))), React.createElement("div", {
      className: "mt-4 mt-md-4"
    }, React.createElement(SocialShare, {
      title: this.title,
      excerpt: this.excerpt,
      path: this.path
    }), React.createElement(Comments, {
      href: this.url
    }), React.createElement(MailChimpBanner))))))));
  }
}
export default function GatsbyMDXWrapper(props) {
  return React.createElement(BlogPostTemplate, props, React.createElement(GATSBY_COMPILED_MDX, props));
}
export const query = graphql`
	query ($id: String!) {
		mdx(id: { eq: $id }) {
			frontmatter {
				title
				path
				category
				excerpt
				keywords
				image {
					childImageSharp {
						gatsbyImageData(width: 1200, layout: CONSTRAINED)
					}
				}
			}
		}
	}
`;
